export function getQueryParameters(): any {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const result = {};
  for (const key of urlSearchParams.keys()) {
    result[key] = urlSearchParams.get(key);
  }
  return result;
}

export function setQueryParameters(data: object) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  Object.keys(data).forEach((key) => {
    if (data[key] != null) {
      urlSearchParams.set(key, data[key]);
    } else {
      urlSearchParams.delete(key);
    }
  });

  const newURL = new URL(window.location.href);
  newURL.search = urlSearchParams.toString();
  window.history.replaceState({ path: newURL.href }, "", newURL.href);
}

export function clearQueryParameters() {
  const newURL = new URL(window.location.href);
  newURL.search = "";
  window.history.replaceState({ path: newURL.href }, "", newURL.href);
}

export function clearSomeQueryParameters(keys: string[]) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  keys.forEach((key) => urlSearchParams.delete(key));

  const newURL = new URL(window.location.href);
  newURL.search = urlSearchParams.toString();
  window.history.replaceState({ path: newURL.href }, "", newURL.href);
}

export function getResolvedUrl(params: Record<string, string | number>, url: string): string {
  const toReplace = Object.entries(params).map(([key, value]) => ({ param: `:${key}`, value }));
  for (const { param, value } of toReplace) {
    url = url.replace(param, `${value}`);
  }
  return url;
}
